import { AxiosService } from '../../../../../../../../axios/axios.service';
import { tAxiosCustomConfig } from '../../../../../../../../axios/axios.types';
import { withTypeFromName } from './DriveFilesAction.function';
import {
  tDriveFilesActionResponse,
  tGetDriveFilesResponse,
} from './DriveFilesAction.types';

export const DriveFilesActionService = {
  getMoreFiles: async function (
    currentWorkspaceId: string,
    cursor: string,
  ): Promise<tDriveFilesActionResponse<tGetDriveFilesResponse>> {
    try {
      const config: tAxiosCustomConfig = {
        params: {
          cursor,
          workspaceId: currentWorkspaceId,
        },
      };

      const response = await AxiosService.get<
        tDriveFilesActionResponse<tGetDriveFilesResponse>
      >(`/storage/drive`, config);

      // Both pickers load the shared folder through here, so a record that
      // came back with no type gets its type once, for every caller (BUG-1067).
      const files = response?.data?.files;

      if (!files) {
        return Promise.resolve(response);
      }

      return Promise.resolve({
        ...response,
        data: { ...response.data, files: files.map(withTypeFromName) },
      });
    } catch (err) {
      return Promise.reject(err);
    }
  },
};
